import { useTranslation } from "react-i18next";

import {
  ResettableOptionButton,
  ResettableOptionButtonProps,
} from "./ResettableOptionButton";

export const ResettableBooleanOptionButton = (
  props: Omit<ResettableOptionButtonProps<boolean>, "options">
) => {
  const { t } = useTranslation();

  return (
    <ResettableOptionButton
      {...props}
      options={[
        {
          label: t("no"),
          value: false,
        },
        {
          label: t("yes"),
          value: true,
        },
      ]}
    />
  );
};
